import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Alert, Button, Col, Row, Table, Form, Badge, InputGroup, Spinner } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { ShimmerTable } from "react-shimmer-effects";
import { ToastContainer, toast } from "react-toastify";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link, useNavigate } from "react-router-dom";
import Confirm from "../Confirm";
import InfoPill from "../InfoPill";
import {
  Editor,
  EditorProvider,
} from "react-simple-wysiwyg";
import { NameInitialsAvatar } from "react-name-initials-avatar";
import Select from "react-select";

import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
import jwt_decode from "jwt-decode";


const Anouncement = (props) => {
  const navigate = useNavigate();
  const [anndetails, setAnnDetails] = useState({
    title: "",
    description: "",
    media: [],
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [btnName, setBtnName] = useState("Save");
  let [reportData, setReportData] = useState({
    date: new Date(),
  });

  const [fileDescription, setFileDescription] = useState("");
  const [newUploadFiles, setNewUploadFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  // Recipient assignment states
  const [recordType, setRecordType] = useState("student");

  // Student assignment states
  const [classList, setClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [studentSearchText, setStudentSearchText] = useState("");
  const [studentPool, setStudentPool] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [showOnlySelected, setShowOnlySelected] = useState(false);

  // Teacher assignment states
  const [teacherSearchText, setTeacherSearchText] = useState("");
  const [teacherPool, setTeacherPool] = useState([]);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [loadingTeachers, setLoadingTeachers] = useState(false);

  // Parent & Group assignment states
  const [otherSearchText, setOtherSearchText] = useState("");
  const [otherPool, setOtherPool] = useState([]);
  const [selectedOthers, setSelectedOthers] = useState([]);
  const [loadingOthers, setLoadingOthers] = useState(false);

  const getStudentKey = (student) => student.student_id || student.id || student.user_id;

  const fetchUpdatedAnouncement = async () => {
    try {
      const anouncementData = await schoolApi.getAllAnouncement();
      if (anouncementData.success) {
        const records = Array.isArray(anouncementData.result)
          ? anouncementData.result
          : anouncementData.result?.AllAnouncements;
        setBody(Array.isArray(records) ? records : []);
      } else {
        setBody([]);
        toast.error(anouncementData.message);
      }
    } catch (error) {
      setBody([]);
      return toast.error(error.response?.data?.message || "Failed to load announcements.");
    }
  };

  useEffect(() => {
    fetchUpdatedAnouncement();
  }, []);

  useEffect(() => {
    async function loadClasses() {
      try {
        const res = await schoolApi.getActiveClassRecords();
        if (res?.result) {
          setClassList(res.result);
        }
      } catch (e) {
        console.error("Error loading classes:", e);
      }
    }
    loadClasses();
  }, []);

  useEffect(() => {
    async function loadSections() {
      if (!selectedClass) {
        setSectionList([]);
        setSelectedSection("");
        return;
      }
      try {
        const res = await schoolApi.getSectionRecordById(selectedClass);
        if (res?.success && res?.record) {
          setSectionList(res.record);
        } else {
          setSectionList([]);
        }
      } catch (e) {
        setSectionList([]);
      }
    }
    loadSections();
  }, [selectedClass]);

  const fetchStudentPool = async (cls = selectedClass, sec = selectedSection, search = studentSearchText) => {
    try {
      setLoadingStudents(true);
      const res = await schoolApi.getFilterData(
        "anouncement",
        search,
        cls,
        "student",
        sec,
        ""
      );
      if (res?.success && res?.records) {
        const unique = [];
        const seen = new Set();
        res.records.forEach((r) => {
          const key = r.student_id || r.id || r.user_id;
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(r);
          }
        });
        setStudentPool(unique);
      } else {
        setStudentPool([]);
      }
    } catch (e) {
      console.error("Error fetching students:", e);
      setStudentPool([]);
    } finally {
      setLoadingStudents(false);
    }
  };

  useEffect(() => {
    if (isModal && recordType === "student") {
      fetchStudentPool(selectedClass, selectedSection, studentSearchText);
    }
  }, [isModal, recordType, selectedClass, selectedSection, studentSearchText]);

  const fetchTeacherPool = async (search = teacherSearchText) => {
    try {
      setLoadingTeachers(true);
      const res = await schoolApi.getFilterData(
        "anouncement",
        search,
        "",
        "teacher",
        "",
        ""
      );
      if (res?.success && res?.records) {
        const unique = [];
        const seen = new Set();
        res.records.forEach((r) => {
          if (!seen.has(r.id)) {
            seen.add(r.id);
            unique.push(r);
          }
        });
        setTeacherPool(unique);
      } else {
        setTeacherPool([]);
      }
    } catch (e) {
      console.error("Error fetching teachers:", e);
      setTeacherPool([]);
    } finally {
      setLoadingTeachers(false);
    }
  };

  useEffect(() => {
    if (isModal && recordType === "teacher") {
      fetchTeacherPool(teacherSearchText);
    }
  }, [isModal, recordType, teacherSearchText]);

  const fetchOtherPool = async (type = recordType, search = otherSearchText) => {
    if (type !== "parent" && type !== "groups") return;
    try {
      setLoadingOthers(true);
      const res = await schoolApi.getFilterData(
        "anouncement",
        search,
        "",
        type,
        "",
        ""
      );
      if (res?.success && res?.records) {
        const unique = [];
        const seen = new Set();
        res.records.forEach((r) => {
          const key = r.id || `${r.contactname}-${r.whatsapp_number || ""}`;
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(r);
          }
        });
        setOtherPool(unique);
      } else {
        setOtherPool([]);
      }
    } catch (e) {
      console.error(`Error fetching ${type}:`, e);
      setOtherPool([]);
    } finally {
      setLoadingOthers(false);
    }
  };

  useEffect(() => {
    if (isModal && (recordType === "parent" || recordType === "groups")) {
      fetchOtherPool(recordType, otherSearchText);
    }
  }, [isModal, recordType, otherSearchText]);

  const fetchAssignedUsers = async (announcementId) => {
    try {
      setLoadingStudents(true);
      setLoadingTeachers(true);
      setLoadingOthers(true);
      const res = await schoolApi.getAnnouncementUsers(announcementId);
      if (res?.success && res?.result) {
        const students = [];
        const teachers = [];
        const others = [];
        res.result.forEach((user) => {
          if (user.recordtype === "teacher") {
            teachers.push({
              id: user.id || user.user_id,
              user_id: user.id || user.user_id,
              contactname: user.contactname || `${user.firstname || ""} ${user.lastname || ""}`.trim(),
              phone: user.phone || user.whatsapp_number || "",
              email: user.email || "",
              recordtype: "teacher",
            });
          } else if (user.recordtype === "parent" || user.recordtype === "groups") {
            others.push({
              id: user.id || user.user_id,
              user_id: user.id || user.user_id,
              contactname: user.contactname || "",
              phone: user.phone || user.whatsapp_number || "",
              recordtype: user.recordtype,
            });
          } else {
            students.push({
              id: user.id || user.user_id,
              user_id: user.id || user.user_id,
              contactname: user.contactname || `${user.firstname || ""} ${user.lastname || ""}`.trim(),
              formno: user.formno || "",
              classname: user.classname || "",
              section_name: user.section_name || user.section || "",
              recordtype: "student",
            });
          }
        });
        setSelectedStudents(students);
        setSelectedTeachers(teachers);
        setSelectedOthers(others);

        if (teachers.length > 0 && students.length === 0) {
          setRecordType("teacher");
        } else if (others.length > 0 && students.length === 0 && teachers.length === 0) {
          setRecordType(others[0].recordtype || "parent");
        } else {
          setRecordType("student");
        }
      } else {
        setSelectedStudents([]);
        setSelectedTeachers([]);
        setSelectedOthers([]);
      }
    } catch (e) {
      console.error("Error fetching assigned users:", e);
      setSelectedStudents([]);
      setSelectedTeachers([]);
      setSelectedOthers([]);
    } finally {
      setLoadingStudents(false);
      setLoadingTeachers(false);
      setLoadingOthers(false);
    }
  };


  // const fetchFiles = async (id) => {
  //   try {

  //     sessionStorage.getItem("token");
  //     const user = jwt_decode(sessionStorage.getItem("token"));

  //     console.log('fetchFiles--->', id);
  //     const response = await schoolApi.fetchFiles(id);
  //     console.log('response--on update->', response);


  //     if (response.success) {

  //       response?.result?.forEach(file => {
  //         let path = process.env.NODE_ENV === "development"
  //           ? `http://localhost:4011/uploads/${id}/${file.id}.${file.filetype}`
  //           : `https://${user.tenantcode}.idigischool.com/uploads/${id}/${file.id}.${file.filetype}`;

  //         console.log('path--->', path);

  //         setPreviewFiles(prevFiles => [
  //           ...prevFiles,
  //           {
  //             name: file.title,
  //             type: `image/${file.filetype}`,
  //             url: path
  //           }
  //         ]);
  //       });

  //       setSelectedFiles(response?.result);
  //     }
  //     else {
  //       toast.error(response.message);
  //     }

  //   } catch (error) {
  //     console.log('error--on update->', error);
  //     return toast.error(error?.response?.data?.message);
  //   }

  // }

  // const fetchFiles = async (id) => {
  //   try {
  //     sessionStorage.getItem("token");
  //     const user = jwt_decode(sessionStorage.getItem("token"));
  
  //     console.log('fetchFiles--->', id);
  //     const response = await schoolApi.fetchFiles(id);
  //     console.log('response--on update->', response);
  
  //     if (response.success) {
  //       const updatedFiles = response.result.map(file => {
  //         let path = process.env.NODE_ENV === "development"
  //           ? `http://localhost:4011/uploads/${id}/${file.id}.${file.filetype}`
  //           : `https://${user.tenantcode}.idigischool.com/uploads/${id}/${file.id}.${file.filetype}`;
  
  //         console.log('path--->', path);
  
  //         // Determine correct MIME type based on file extension
  //         let fileType = "";
  //         if (["png", "jpg", "jpeg", "gif"].includes(file.filetype)) {
  //           fileType = `image/${file.filetype}`;
  //         } else if (["mp4", "webm", "ogg"].includes(file.filetype)) {
  //           fileType = `video/${file.filetype}`;
  //         } else if (["pdf"].includes(file.filetype)) {
  //           fileType = "application/pdf";
  //         } else {
  //           fileType = "application/octet-stream"; // Generic for unknown types
  //         }
  
  //         return {
  //           name: file.title,
  //           type: fileType,
  //           url: path
  //         };
  //       });
  
  //       setPreviewFiles(updatedFiles); // Avoid unnecessary spread
  //       setSelectedFiles(response.result);
  //     } else {
  //       toast.error(response.message);
  //     }
  //   } catch (error) {
  //     console.log('error--on update->', error);
  //     return toast.error(error?.response?.data?.message);
  //   }
  // };
  
  const fetchFiles = async (id) => {
    try {
      const token = sessionStorage.getItem("token");
      let user = null;
      try {
        user = token ? jwt_decode(token) : null;
      } catch (e) {
        user = null;
      }

      const defaultProfile = "/user_images/profile.png";

      const buildFileUrl = (file) => {
        const timestamp = new Date().getTime();
        const fileParentId = file?.file_parent_id ?? file?.fileParentId ?? file?.parentid;
        const fileId = file?.file_id ?? file?.fileId ?? file?.id;
        const fileTypeExt = file?.file_type ?? file?.fileType ?? file?.filetype;

        const hasRequiredShape =
          fileParentId != null && fileId != null && fileTypeExt;

        const tenantPrefix = user?.tenantcode;

        if (hasRequiredShape && tenantPrefix) {
          return `/uploads/${tenantPrefix}/${fileParentId}/${fileId}.${fileTypeExt}?v=${timestamp}`;
        }

        const legacyFileId = file?.id;
        const legacyFileType = file?.filetype;
        if (legacyFileId && legacyFileType && tenantPrefix) {
          return `https://${tenantPrefix}.idigischool.com/uploads/${id}/${legacyFileId}.${legacyFileType}?v=${timestamp}`;
        }

        return defaultProfile;
      };

      const response = await schoolApi.fetchFiles(id);

      if (response.success) {
        const updatedFiles = response.result.map((file) => {
          const path = buildFileUrl(file);

          const mimeTypes = {
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            mp4: "video/mp4",
            webm: "video/webm",
            ogg: "video/ogg",
            pdf: "application/pdf",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            csv: "text/csv",
            txt: "text/plain",
          };

          const ext = file?.filetype ?? file?.file_type ?? file?.fileType;
          const fileType = mimeTypes[ext] || "application/octet-stream";

          return {
            id: file.id,
            name: file?.title,
            type: fileType,
            url: path,
            isExisting: true,
          };
        });

        setPreviewFiles(updatedFiles);
        setSelectedFiles(response.result);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("error--on update->", error);
      return toast.error(error?.response?.data?.message || "Failed to fetch files.");
    }
  };

  const handleEditButton = (row) => {
    setNewUploadFiles([]);
    setPreviewFiles([]);
    setSelectedFiles([]);
    setSelectedStudents([]);
    setSelectedTeachers([]);
    setSelectedOthers([]);
    setSelectedClass("");
    setSelectedSection("");
    setStudentSearchText("");
    setTeacherSearchText("");
    setOtherSearchText("");
    setShowOnlySelected(false);
    setRecordType("student");

    if (row.id) {
      fetchFiles(row.id);
      fetchAssignedUsers(row.id);
    }

    setAnnDetails({
      id: row.id,
      title: row.title || "",
      description: row.description || "",
    });
    setIsModal(true);
    setBtnName("Update");
  };

  const handleDeleteButton = (row) => {
    setAnnDetails(row);
    setModalShow(true);
  };

  const handleDeleteAndNavigate = async () => {
    if (anndetails) {
      try {
        const response = await schoolApi.deleteAnouncement(anndetails.id);
        toast.success(response.message);
        setModalShow(false);
        fetchUpdatedAnouncement();
      } catch (error) {
        return toast.error(error.response.data.message);
      }
    }
    setModalShow(false);
  };

  const handleFileChange = (e) => {
    let files = Array.from(e.target.files);
    if (files.length === 0) return;

    if (previewFiles.length + files.length > 10) {
      return toast.error("You can only upload up to 10 files at a time.");
    }

    setNewUploadFiles((prev) => [...prev, ...files]);

    const newPreviews = files.map((file) => ({
      name: file.name,
      type: file.type || "application/octet-stream",
      url: URL.createObjectURL(file),
      isExisting: false,
      fileRef: file,
    }));

    setPreviewFiles((prev) => [...prev, ...newPreviews]);
  };

  const removeFile = async (index) => {
    const fileToRemove = previewFiles[index];
    if (fileToRemove?.isExisting && fileToRemove?.id) {
      try {
        await schoolApi.deleteFile(fileToRemove.id);
        toast.info("Attachment removed.");
      } catch (err) {
        console.error("Error deleting file:", err);
      }
    } else if (fileToRemove?.fileRef) {
      setNewUploadFiles((prev) => prev.filter((f) => f !== fileToRemove.fileRef));
    }
    setPreviewFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const isStudentSelected = (studentId) => {
    return selectedStudents.some((s) => getStudentKey(s) === studentId);
  };

  const handleToggleStudent = (student) => {
    const studentId = getStudentKey(student);
    if (isStudentSelected(studentId)) {
      setSelectedStudents((prev) => prev.filter((s) => getStudentKey(s) !== studentId));
    } else {
      setSelectedStudents((prev) => [
        ...prev,
        {
          id: student.id || student.user_id,
          user_id: student.id || student.user_id,
          student_id: student.student_id,
          contactname: student.contactname || `${student.firstname || ""} ${student.lastname || ""}`.trim(),
          formno: student.formno || "",
          classname: student.classname || "",
          section_name: student.section_name || student.section || "",
        },
      ]);
    }
  };

  const displayedStudents = showOnlySelected ? selectedStudents : studentPool;

  const allVisibleSelected =
    displayedStudents.length > 0 &&
    displayedStudents.every((s) => isStudentSelected(getStudentKey(s)));

  const handleToggleSelectAllVisible = () => {
    if (allVisibleSelected) {
      const visibleIds = new Set(displayedStudents.map(getStudentKey));
      setSelectedStudents((prev) => prev.filter((s) => !visibleIds.has(getStudentKey(s))));
    } else {
      const existingIds = new Set(selectedStudents.map(getStudentKey));
      const toAdd = displayedStudents
        .filter((s) => !existingIds.has(getStudentKey(s)))
        .map((s) => ({
          id: s.id || s.user_id,
          user_id: s.id || s.user_id,
          student_id: s.student_id,
          contactname: s.contactname || `${s.firstname || ""} ${s.lastname || ""}`.trim(),
          formno: s.formno || "",
          classname: s.classname || "",
          section_name: s.section_name || s.section || "",
        }));
      setSelectedStudents((prev) => [...prev, ...toAdd]);
    }
  };

  // Teacher selection helpers
  const isTeacherSelected = (teacherId) => {
    return selectedTeachers.some((t) => (t.id || t.user_id) === teacherId);
  };

  const handleToggleTeacher = (teacher) => {
    const teacherId = teacher.id || teacher.user_id;
    if (isTeacherSelected(teacherId)) {
      setSelectedTeachers((prev) => prev.filter((t) => (t.id || t.user_id) !== teacherId));
    } else {
      setSelectedTeachers((prev) => [
        ...prev,
        {
          id: teacherId,
          user_id: teacherId,
          contactname: teacher.contactname || `${teacher.firstname || ""} ${teacher.lastname || ""}`.trim(),
          phone: teacher.whatsapp_number || teacher.phone || "",
          email: teacher.email || "",
          recordtype: "teacher",
        },
      ]);
    }
  };

  const displayedTeachers = showOnlySelected ? selectedTeachers : teacherPool;

  const allVisibleTeachersSelected =
    displayedTeachers.length > 0 &&
    displayedTeachers.every((t) => isTeacherSelected(t.id || t.user_id));

  const handleToggleSelectAllVisibleTeachers = () => {
    if (allVisibleTeachersSelected) {
      const visibleIds = new Set(displayedTeachers.map((t) => t.id || t.user_id));
      setSelectedTeachers((prev) => prev.filter((t) => !visibleIds.has(t.id || t.user_id)));
    } else {
      const existingIds = new Set(selectedTeachers.map((t) => t.id || t.user_id));
      const toAdd = displayedTeachers
        .filter((t) => !existingIds.has(t.id || t.user_id))
        .map((t) => ({
          id: t.id || t.user_id,
          user_id: t.id || t.user_id,
          contactname: t.contactname || `${t.firstname || ""} ${t.lastname || ""}`.trim(),
          phone: t.whatsapp_number || t.phone || "",
          email: t.email || "",
          recordtype: "teacher",
        }));
      setSelectedTeachers((prev) => [...prev, ...toAdd]);
    }
  };

  const teacherOptions = teacherPool.map((t) => ({
    value: t.id || t.user_id,
    label: `${t.contactname || ""}${t.whatsapp_number || t.phone ? ` (${t.whatsapp_number || t.phone})` : ""}`,
    raw: t,
  }));

  const selectedTeacherOptions = selectedTeachers.map((t) => ({
    value: t.id || t.user_id,
    label: `${t.contactname || ""}${t.phone || t.whatsapp_number ? ` (${t.phone || t.whatsapp_number})` : ""}`,
    raw: t,
  }));

  const handleTeacherDropdownChange = (selectedOpts) => {
    const list = (selectedOpts || []).map((opt) => ({
      id: opt.value,
      user_id: opt.value,
      contactname: opt.raw?.contactname || opt.label,
      phone: opt.raw?.whatsapp_number || opt.raw?.phone || "",
      email: opt.raw?.email || "",
      recordtype: "teacher",
    }));
    setSelectedTeachers(list);
  };

  // Other recipient (Parent/Group) helpers
  const isOtherSelected = (otherId) => {
    return selectedOthers.some((o) => (o.id || o.user_id) === otherId);
  };

  const handleToggleOther = (item) => {
    const otherId = item.id || item.user_id;
    if (isOtherSelected(otherId)) {
      setSelectedOthers((prev) => prev.filter((o) => (o.id || o.user_id) !== otherId));
    } else {
      setSelectedOthers((prev) => [
        ...prev,
        {
          id: otherId,
          user_id: otherId,
          contactname: item.contactname || "",
          phone: item.whatsapp_number || item.phone || "",
          recordtype: recordType,
        },
      ]);
    }
  };

  const displayedOthers = showOnlySelected ? selectedOthers : otherPool;

  const allVisibleOthersSelected =
    displayedOthers.length > 0 &&
    displayedOthers.every((o) => isOtherSelected(o.id || o.user_id));

  const handleToggleSelectAllVisibleOthers = () => {
    if (allVisibleOthersSelected) {
      const visibleIds = new Set(displayedOthers.map((o) => o.id || o.user_id));
      setSelectedOthers((prev) => prev.filter((o) => !visibleIds.has(o.id || o.user_id)));
    } else {
      const existingIds = new Set(selectedOthers.map((o) => o.id || o.user_id));
      const toAdd = displayedOthers
        .filter((o) => !existingIds.has(o.id || o.user_id))
        .map((o) => ({
          id: o.id || o.user_id,
          user_id: o.id || o.user_id,
          contactname: o.contactname || "",
          phone: o.whatsapp_number || o.phone || "",
          recordtype: recordType,
        }));
      setSelectedOthers((prev) => [...prev, ...toAdd]);
    }
  };

  const header = [
    {
      title: "Title",
      prop: "title",
      isFilterable: true,
      cell: (row) => (
        <Link
          to={`/announcements/${row.id}`}
          state={row}
          className="text-primary fw-semibold text-decoration-none"
          style={{ cursor: "pointer" }}
          title="View Announcement Details"
        >
          {row.title}
        </Link>
      ),
    },
    {
      title: "Description",
      prop: "description",
      isFilterable: true,
      cell: (row) => (
        <div
          style={{
            maxHeight: "80px",
            overflowY: "auto",
            wordBreak: "break-word",
            lineHeight: "1.4",
            fontSize: "0.9rem",
          }}
          dangerouslySetInnerHTML={{ __html: row.description || "" }}
        />
      ),
    },
    {
      title: "Action",
      prop: "",
      isFilterable: true,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <button
            className="btn btn-sm btn-info text-white mx-1"
            onClick={() => navigate(`/announcements/${row.id}`, { state: row })}
            title="View Details"
          >
            <i className="fa-regular fa-eye"></i>
          </button>
          <button
            className="btn btn-sm edit-button mx-1"
            onClick={() => handleEditButton(row)}
            title="Edit Announcement"
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </button>
          <button
            className="btn btn-sm btn-danger mx-1"
            onClick={() => handleDeleteButton(row)}
            title="Delete Announcement"
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </div>
      ),
    },
  ];

  const labels = {
    beforeSelect: " ",
  };

  const handleShowModal = () => {
    setBtnName("Save");
    setAnnDetails({
      title: "",
      description: "",
    });
    setSelectedFiles([]);
    setPreviewFiles([]);
    setNewUploadFiles([]);
    setSelectedStudents([]);
    setSelectedTeachers([]);
    setSelectedOthers([]);
    setSelectedClass("");
    setSelectedSection("");
    setStudentSearchText("");
    setTeacherSearchText("");
    setOtherSearchText("");
    setShowOnlySelected(false);
    setRecordType("student");
    setIsModal(true);
  };

  const handleCloseModal = () => {
    setIsModal(false);
    fetchUpdatedAnouncement();
  };

  const headerStyle = {
    backgroundColor: "lightblue",
  };

  const handleSave = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!anndetails.title || anndetails.title.trim() === "") {
      toast.error("Title is required.");
      return;
    }

    try {
      setSubmitting(true);
      const combinedUsers = [
        ...selectedStudents.map((s) => ({ id: s.id || s.user_id })),
        ...selectedTeachers.map((t) => ({ id: t.id || t.user_id })),
        ...selectedOthers.map((o) => ({ id: o.id || o.user_id })),
      ];

      if (btnName === "Update") {
        const updatePayload = {
          id: anndetails.id,
          title: anndetails.title.trim(),
          description: anndetails.description || "",
          users: combinedUsers,
        };

        const updateAnouncement = await schoolApi.updateAnouncement(updatePayload);
        if (updateAnouncement.success === true) {
          if (newUploadFiles.length > 0) {
            for (let i = 0; i < newUploadFiles.length; i++) {
              let formData = new FormData();
              formData.append(`files${i}`, newUploadFiles[i]);
              formData.append(`description`, fileDescription || "");
              await schoolApi.createFile(anndetails.id, formData);
            }
          }

          toast.success(updateAnouncement.message || "Announcement updated successfully!");
          setIsModal(false);
          fetchUpdatedAnouncement();
          window.dispatchEvent(new CustomEvent("refreshNotifications"));
        } else {
          return toast.error(updateAnouncement.message || "Failed to update announcement.");
        }
      } else {
        const hasFiles = newUploadFiles && newUploadFiles.length > 0;
        const announcementData = {
          title: anndetails.title.trim(),
          description: anndetails.description || "",
          users: combinedUsers,
          hasFiles,
        };

        const createdAnouncement = await schoolApi.createAnouncement(announcementData);

        if (createdAnouncement.success === true) {
          if (hasFiles) {
            for (let i = 0; i < newUploadFiles.length; i++) {
              let formData = new FormData();
              formData.append(`files${i}`, newUploadFiles[i]);
              formData.append(`description`, fileDescription || "");
              await schoolApi.createFile(createdAnouncement?.record?.id, formData);
            }

            // Trigger push notification after attachments are uploaded to server
            try {
              const notificationDetails = {
                users: combinedUsers,
                announcementRecord: createdAnouncement?.record,
              };
              await schoolApi.sendPushNotification(notificationDetails);
            } catch (notifErr) {
              console.error("Error sending push notification after file upload:", notifErr);
            }
          }

          setIsModal(false);
          toast.success(createdAnouncement.message || "Announcement created successfully!");
          fetchUpdatedAnouncement();
          window.dispatchEvent(new CustomEvent("refreshNotifications"));
        } else {
          return toast.error(createdAnouncement.message || "Failed to create announcement.");
        }
      }
      setAnnDetails({
        title: "",
        description: "",
      });
      setSelectedFiles([]);
      setPreviewFiles([]);
      setNewUploadFiles([]);
    } catch (error) {
      console.error("Error saving announcement:", error);
      return toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setSubmitting(false);
    }
  };

  const createAnouncement = () => {
    //   canEdit ||
    //   userInfo?.userrole === "SYS_ADMIN" ||
    //   userInfo?.userrole === "ADMIN"
    // ) {
    navigate(`/createanouncement`);
    //}
  };


  console.log('anouncement details-->', anndetails);

  console.log('previewFiles-->', previewFiles);
  console.log('selectedFiles-->', selectedFiles);

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>

      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          handleDeleteButton={() => handleDeleteAndNavigate()}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="announcement"
        />
      )}
      <Col lg={2} className="mx-4">
        <Row>
          <Col lg={12}>
            <Link className="nav-link" to="/">
              Home <i className="fa-solid fa-chevron-right"></i> Announcements
            </Link>
          </Col>
        </Row>
      </Col>

      {successMessage && (
        <Alert
          variant="success"
          onClose={() => setSuccessMessage(null)}
          dismissible
        >
          {successMessage}
        </Alert>
      )}
      <Row className="g-0">
        <Col lg={12} className="px-lg-4">
          {Array.isArray(body) ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={3}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={5}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  <PaginationOptions labels={labels} />
                  <div style={{ marginTop: "5px" }}>
                    <InfoPill left="Total Anouncements" right={body?.length} />
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-light add-new-button"
                    variant=""
                    onClick={() => createAnouncement(true)}
                  >
                    New Anouncement
                  </Button>
                </Col>
              </Row>
              <Table striped className="data-table">
                <TableHeader headerStyles={headerStyle} />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Modal
          show={isModal}
          onHide={handleCloseModal}
          size="xl"
          centered
          className="modal-dialog-scrollable"
          backdrop="static"
        >
          <Modal.Header closeButton className="bg-light">
            <Modal.Title className="h5 fw-bold text-primary mb-0">
              <i className="fa-regular fa-pen-to-square me-2"></i>
              {btnName === "Update" ? "Edit Announcement" : "Create Announcement"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <Row className="g-4">
              {/* Left Column: Details */}
              <Col lg={6} md={12} className="border-end pe-lg-4">
                <h6 className="fw-bold text-dark mb-3 border-bottom pb-2">
                  <i className="fa-solid fa-bullhorn text-primary me-2"></i>Announcement Details
                </h6>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small text-muted">TITLE *</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    placeholder="Enter Announcement Title"
                    value={anndetails.title}
                    onChange={(e) =>
                      setAnnDetails({
                        ...anndetails,
                        title: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small text-muted">DESCRIPTION</Form.Label>
                  <div className="border rounded-2 bg-white overflow-hidden" style={{ minHeight: "160px" }}>
                    <EditorProvider>
                      <Editor
                        name="description"
                        placeholder="Enter announcement description..."
                        value={anndetails.description || ""}
                        onChange={(e) =>
                          setAnnDetails({
                            ...anndetails,
                            description: e.target.value,
                          })
                        }
                        style={{ minHeight: "150px", border: "none" }}
                      />
                    </EditorProvider>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold small text-muted">ATTACHMENTS</Form.Label>
                  <Form.Control
                    type="file"
                    multiple
                    onChange={handleFileChange}
                    className="mb-2"
                    accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
                  />
                  {previewFiles.length > 0 && (
                    <div className="d-flex flex-wrap gap-2 mt-2 p-2 bg-light rounded border">
                      {previewFiles.map((file, index) => (
                        <div
                          key={index}
                          className="file-preview d-flex align-items-center p-2 bg-white border rounded shadow-sm"
                          style={{ maxWidth: "260px" }}
                        >
                          {file.type?.startsWith("image/") ? (
                            <img
                              src={file.url}
                              alt={file.name}
                              style={{ width: "36px", height: "36px", objectFit: "cover", borderRadius: "4px" }}
                            />
                          ) : file.type?.startsWith("video/") ? (
                            <i className="fa-solid fa-file-video text-warning fs-4 me-2"></i>
                          ) : file.type === "application/pdf" ? (
                            <i className="fa-solid fa-file-pdf text-danger fs-4 me-2"></i>
                          ) : (
                            <i className="fa-solid fa-file text-secondary fs-4 me-2"></i>
                          )}
                          <span className="ms-2 small text-truncate" title={file.name} style={{ maxWidth: "160px" }}>
                            {file.name}
                          </span>
                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 text-danger ms-auto"
                            onClick={() => removeFile(index)}
                            title="Remove file"
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </Form.Group>
              </Col>

              {/* Right Column: Assign Recipients */}
              <Col lg={6} md={12} className="ps-lg-4">
                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                  <h6 className="fw-bold text-dark mb-0">
                    <i className="fa-solid fa-users text-primary me-2"></i>
                    {recordType === "teacher"
                      ? "Assign / Reassign Teachers"
                      : recordType === "parent"
                      ? "Assign / Reassign Parents"
                      : recordType === "groups"
                      ? "Assign / Reassign Groups"
                      : "Assign / Reassign Students"}
                  </h6>
                  <div className="d-flex align-items-center gap-2">
                    <Badge
                      bg={
                        (recordType === "teacher"
                          ? selectedTeachers.length
                          : recordType === "parent" || recordType === "groups"
                          ? selectedOthers.length
                          : selectedStudents.length) > 0
                          ? "success"
                          : "secondary"
                      }
                      className="px-2 py-1"
                    >
                      {recordType === "teacher"
                        ? `${selectedTeachers.length} Selected`
                        : recordType === "parent" || recordType === "groups"
                        ? `${selectedOthers.length} Selected`
                        : `${selectedStudents.length} Selected`}
                    </Badge>
                    <Button
                      variant={showOnlySelected ? "primary" : "outline-primary"}
                      size="sm"
                      className="py-0 px-2"
                      style={{ fontSize: "0.75rem" }}
                      onClick={() => setShowOnlySelected(!showOnlySelected)}
                    >
                      {showOnlySelected ? "Show All" : "View Selected"}
                    </Button>
                  </div>
                </div>

                {/* Recipient Type Selector */}
                <div className="p-2 bg-light rounded-3 border mb-2">
                  <Row className="g-2 align-items-center">
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small text-muted mb-1">
                          <i className="fa-solid fa-user-tag text-primary me-1"></i>RECIPIENT TYPE *
                        </Form.Label>
                        <Form.Select
                          size="sm"
                          value={recordType}
                          onChange={(e) => {
                            setRecordType(e.target.value);
                            setShowOnlySelected(false);
                          }}
                          className="fw-semibold text-dark shadow-none border-primary bg-white"
                        >
                          <option value="student">Student</option>
                          <option value="parent">Parent</option>
                          <option value="groups">Groups</option>
                          <option value="teacher">Teacher</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm={6} className="text-end pt-3">
                      <div className="small">
                        {selectedStudents.length > 0 && (
                          <Badge bg="info" className="me-1 text-white" title={`${selectedStudents.length} Students Selected`}>
                            <i className="fa-solid fa-user-graduate me-1"></i>
                            {selectedStudents.length} Student{selectedStudents.length > 1 ? "s" : ""}
                          </Badge>
                        )}
                        {selectedTeachers.length > 0 && (
                          <Badge bg="success" className="me-1" title={`${selectedTeachers.length} Teachers Selected`}>
                            <i className="fa-solid fa-chalkboard-user me-1"></i>
                            {selectedTeachers.length} Teacher{selectedTeachers.length > 1 ? "s" : ""}
                          </Badge>
                        )}
                        {selectedOthers.length > 0 && (
                          <Badge bg="secondary" className="me-1">
                            <i className="fa-solid fa-users me-1"></i>
                            {selectedOthers.length} Other{selectedOthers.length > 1 ? "s" : ""}
                          </Badge>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Teacher Recipient Mode */}
                {recordType === "teacher" && (
                  <>
                    {/* Teacher Selection Dropdown */}
                    <Form.Group className="mb-2">
                      <Form.Label className="fw-bold small text-muted mb-1">
                        <i className="fa-solid fa-chalkboard-user text-primary me-1"></i>TEACHER SELECTION (DROPDOWN)
                      </Form.Label>
                      <Select
                        isMulti
                        name="teachers"
                        options={teacherOptions}
                        value={selectedTeacherOptions}
                        onChange={handleTeacherDropdownChange}
                        placeholder="Select one or more teachers..."
                        closeMenuOnSelect={false}
                        className="basic-multi-select small mb-1"
                        classNamePrefix="select"
                        noOptionsMessage={() => (loadingTeachers ? "Loading teachers..." : "No teachers found")}
                        isLoading={loadingTeachers}
                      />
                    </Form.Group>

                    {/* Teacher Filter Controls */}
                    <div className="p-2 bg-light rounded-3 border mb-2">
                      <InputGroup size="sm">
                        <InputGroup.Text className="bg-white border-end-0">
                          <i className="fa-solid fa-magnifying-glass text-muted"></i>
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Search teacher by name or phone..."
                          value={teacherSearchText}
                          onChange={(e) => setTeacherSearchText(e.target.value)}
                          className="border-start-0"
                          disabled={showOnlySelected}
                        />
                        {teacherSearchText && (
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setTeacherSearchText("")}
                            className="border-start-0 bg-white"
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </Button>
                        )}
                      </InputGroup>

                      <div className="d-flex justify-content-between align-items-center mt-2 pt-1 border-top">
                        <Form.Check
                          type="checkbox"
                          id="select-all-teachers-checkbox"
                          label={`Select All Visible (${displayedTeachers.length})`}
                          checked={allVisibleTeachersSelected}
                          onChange={handleToggleSelectAllVisibleTeachers}
                          className="small fw-bold text-muted"
                        />
                        {selectedTeachers.length > 0 && (
                          <Button
                            variant="link"
                            size="sm"
                            className="text-danger p-0 text-decoration-none small"
                            onClick={() => setSelectedTeachers([])}
                          >
                            <i className="fa-solid fa-xmark me-1"></i>Clear All
                          </Button>
                        )}
                      </div>
                    </div>

                    {/* Teacher List */}
                    <div
                      style={{ maxHeight: "250px", overflowY: "auto" }}
                      className="border rounded-2 p-2 bg-white"
                    >
                      {loadingTeachers ? (
                        <div className="text-center py-5 text-muted small">
                          <Spinner animation="border" size="sm" className="me-2 text-primary" />
                          Loading teachers...
                        </div>
                      ) : displayedTeachers.length === 0 ? (
                        <div className="text-center py-5 text-muted small">
                          <i className="fa-solid fa-chalkboard-user d-block fs-3 mb-2 opacity-50"></i>
                          {showOnlySelected ? "No teachers currently selected." : "No teachers found."}
                        </div>
                      ) : (
                        displayedTeachers.map((teacher) => {
                          const teacherId = teacher.id || teacher.user_id;
                          const selected = isTeacherSelected(teacherId);
                          const teacherName =
                            teacher.contactname ||
                            `${teacher.firstname || ""} ${teacher.lastname || ""}`.trim() ||
                            "Teacher";
                          const phone = teacher.whatsapp_number || teacher.phone;
                          return (
                            <div
                              key={teacherId}
                              onClick={() => handleToggleTeacher(teacher)}
                              className={`d-flex align-items-center p-2 rounded-2 mb-1 cursor-pointer transition ${
                                selected ? "bg-primary bg-opacity-10 border border-primary" : "bg-light border-0"
                              }`}
                              style={{ cursor: "pointer" }}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={selected}
                                onChange={() => {}}
                                className="me-2"
                                onClick={(e) => e.stopPropagation()}
                              />
                              <div className="me-2">
                                <NameInitialsAvatar
                                  name={teacherName}
                                  size="30px"
                                  textSize="11px"
                                />
                              </div>
                              <div className="flex-grow-1 overflow-hidden">
                                <div className="d-flex align-items-center">
                                  <span className="small fw-bold text-dark text-truncate me-2">
                                    {teacherName}
                                  </span>
                                  <Badge bg="info" className="me-1" style={{ fontSize: "0.65rem" }}>
                                    Teacher
                                  </Badge>
                                </div>
                                <div className="text-muted text-truncate" style={{ fontSize: "0.72rem" }}>
                                  {phone && (
                                    <span className="me-2">
                                      <i className="fa-solid fa-phone me-1 text-success"></i>
                                      {phone}
                                    </span>
                                  )}
                                  {teacher.email && (
                                    <span>
                                      <i className="fa-solid fa-envelope me-1 text-secondary"></i>
                                      {teacher.email}
                                    </span>
                                  )}
                                </div>
                              </div>
                              {selected && (
                                <Badge bg="success" pill className="ms-2" style={{ fontSize: "0.65rem" }}>
                                  <i className="fa-solid fa-check me-1"></i>Assigned
                                </Badge>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </>
                )}

                {/* Parent / Groups Recipient Mode */}
                {(recordType === "parent" || recordType === "groups") && (
                  <>
                    <div className="p-2 bg-light rounded-3 border mb-2">
                      <InputGroup size="sm">
                        <InputGroup.Text className="bg-white border-end-0">
                          <i className="fa-solid fa-magnifying-glass text-muted"></i>
                        </InputGroup.Text>
                        <Form.Control
                          placeholder={`Search ${recordType === "groups" ? "group" : "parent"} by name...`}
                          value={otherSearchText}
                          onChange={(e) => setOtherSearchText(e.target.value)}
                          className="border-start-0"
                          disabled={showOnlySelected}
                        />
                      </InputGroup>

                      <div className="d-flex justify-content-between align-items-center mt-2 pt-1 border-top">
                        <Form.Check
                          type="checkbox"
                          id="select-all-others-checkbox"
                          label={`Select All Visible (${displayedOthers.length})`}
                          checked={allVisibleOthersSelected}
                          onChange={handleToggleSelectAllVisibleOthers}
                          className="small fw-bold text-muted"
                        />
                        {selectedOthers.length > 0 && (
                          <Button
                            variant="link"
                            size="sm"
                            className="text-danger p-0 text-decoration-none small"
                            onClick={() => setSelectedOthers([])}
                          >
                            <i className="fa-solid fa-xmark me-1"></i>Clear All
                          </Button>
                        )}
                      </div>
                    </div>

                    <div
                      style={{ maxHeight: "310px", overflowY: "auto" }}
                      className="border rounded-2 p-2 bg-white"
                    >
                      {loadingOthers ? (
                        <div className="text-center py-5 text-muted small">
                          <Spinner animation="border" size="sm" className="me-2 text-primary" />
                          Loading {recordType}...
                        </div>
                      ) : displayedOthers.length === 0 ? (
                        <div className="text-center py-5 text-muted small">
                          <i className="fa-solid fa-users-slash d-block fs-3 mb-2 opacity-50"></i>
                          {showOnlySelected ? `No ${recordType} currently selected.` : `No ${recordType} found.`}
                        </div>
                      ) : (
                        displayedOthers.map((item) => {
                          const itemId = item.id || item.user_id;
                          const selected = isOtherSelected(itemId);
                          const itemName = item.contactname || item.name || "Recipient";
                          return (
                            <div
                              key={itemId}
                              onClick={() => handleToggleOther(item)}
                              className={`d-flex align-items-center p-2 rounded-2 mb-1 cursor-pointer transition ${
                                selected ? "bg-primary bg-opacity-10 border border-primary" : "bg-light border-0"
                              }`}
                              style={{ cursor: "pointer" }}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={selected}
                                onChange={() => {}}
                                className="me-2"
                                onClick={(e) => e.stopPropagation()}
                              />
                              <div className="me-2">
                                <NameInitialsAvatar
                                  name={itemName}
                                  size="30px"
                                  textSize="11px"
                                />
                              </div>
                              <div className="flex-grow-1 overflow-hidden">
                                <span className="small fw-bold text-dark text-truncate me-2">
                                  {itemName}
                                </span>
                                {item.whatsapp_number && (
                                  <div className="text-muted" style={{ fontSize: "0.72rem" }}>
                                    <i className="fa-solid fa-phone me-1 text-success"></i>
                                    {item.whatsapp_number}
                                  </div>
                                )}
                              </div>
                              {selected && (
                                <Badge bg="success" pill className="ms-2" style={{ fontSize: "0.65rem" }}>
                                  <i className="fa-solid fa-check me-1"></i>Assigned
                                </Badge>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </>
                )}

                {/* Student Recipient Mode */}
                {recordType === "student" && (
                  <>
                    {/* Filter controls */}
                    <div className="p-2 bg-light rounded-3 border mb-2">
                      <Row className="g-2 mb-2">
                        <Col sm={6}>
                          <Form.Select
                            size="sm"
                            value={selectedClass}
                            onChange={(e) => setSelectedClass(e.target.value)}
                            disabled={showOnlySelected}
                          >
                            <option value="">-- All Classes --</option>
                            {classList.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.classname}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col sm={6}>
                          <Form.Select
                            size="sm"
                            value={selectedSection}
                            onChange={(e) => setSelectedSection(e.target.value)}
                            disabled={showOnlySelected || !selectedClass}
                          >
                            <option value="">-- All Sections --</option>
                            {sectionList.map((s) => (
                              <option key={s.id} value={s.id}>
                                {s.name}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Row>

                      <InputGroup size="sm">
                        <InputGroup.Text className="bg-white border-end-0">
                          <i className="fa-solid fa-magnifying-glass text-muted"></i>
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Search student by name or form no..."
                          value={studentSearchText}
                          onChange={(e) => setStudentSearchText(e.target.value)}
                          className="border-start-0"
                          disabled={showOnlySelected}
                        />
                      </InputGroup>

                      <div className="d-flex justify-content-between align-items-center mt-2 pt-1 border-top">
                        <Form.Check
                          type="checkbox"
                          id="select-all-checkbox"
                          label={`Select All Visible (${displayedStudents.length})`}
                          checked={allVisibleSelected}
                          onChange={handleToggleSelectAllVisible}
                          className="small fw-bold text-muted"
                        />
                        {selectedStudents.length > 0 && (
                          <Button
                            variant="link"
                            size="sm"
                            className="text-danger p-0 text-decoration-none small"
                            onClick={() => setSelectedStudents([])}
                          >
                            <i className="fa-solid fa-xmark me-1"></i>Clear All
                          </Button>
                        )}
                      </div>
                    </div>

                    {/* Students list */}
                    <div
                      style={{ maxHeight: "310px", overflowY: "auto" }}
                      className="border rounded-2 p-2 bg-white"
                    >
                      {loadingStudents ? (
                        <div className="text-center py-5 text-muted small">
                          <Spinner animation="border" size="sm" className="me-2 text-primary" />
                          Loading students...
                        </div>
                      ) : displayedStudents.length === 0 ? (
                        <div className="text-center py-5 text-muted small">
                          <i className="fa-solid fa-user-slash d-block fs-3 mb-2 opacity-50"></i>
                          {showOnlySelected ? "No students currently selected." : "No students found."}
                        </div>
                      ) : (
                        displayedStudents.map((student) => {
                          const studentId = getStudentKey(student);
                          const selected = isStudentSelected(studentId);
                          const studentName =
                            student.contactname ||
                            `${student.firstname || ""} ${student.lastname || ""}`.trim() ||
                            "Student";
                          return (
                            <div
                              key={studentId}
                              onClick={() => handleToggleStudent(student)}
                              className={`d-flex align-items-center p-2 rounded-2 mb-1 cursor-pointer transition ${
                                selected ? "bg-primary bg-opacity-10 border border-primary" : "bg-light border-0"
                              }`}
                              style={{ cursor: "pointer" }}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={selected}
                                onChange={() => {}}
                                className="me-2"
                                onClick={(e) => e.stopPropagation()}
                              />
                              <div className="me-2">
                                <NameInitialsAvatar
                                  name={studentName}
                                  size="30px"
                                  textSize="11px"
                                />
                              </div>
                              <div className="flex-grow-1 overflow-hidden">
                                <div className="d-flex align-items-center">
                                  <span className="small fw-bold text-dark text-truncate me-2">
                                    {studentName}
                                  </span>
                                  {student.formno && (
                                    <Badge bg="light" text="dark" className="border me-1" style={{ fontSize: "0.65rem" }}>
                                      {student.formno}
                                    </Badge>
                                  )}
                                </div>
                                <span className="text-muted" style={{ fontSize: "0.72rem" }}>
                                  {student.classname ? `Class: ${student.classname}` : ""}
                                  {student.section_name || student.section ? ` (${student.section_name || student.section})` : ""}
                                </span>
                              </div>
                              {selected && (
                                <Badge bg="success" pill className="ms-2" style={{ fontSize: "0.65rem" }}>
                                  <i className="fa-solid fa-check me-1"></i>Assigned
                                </Badge>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </>
                )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="secondary" onClick={handleCloseModal} disabled={submitting}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave} disabled={submitting}>
              {submitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Saving...
                </>
              ) : (
                <>
                  <i className="fa-solid fa-check me-2"></i>
                  {btnName === "Update" ? "Update Announcement" : "Create Announcement"}
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
        />
        <Col lg={2}></Col>
      </Row>
    </>
  );
};

export default Anouncement;
